import React from "react";
import logo from "../assets/deft-logo.jpeg";
import { Link } from "react-router-dom";

export const Navigation = (props) => {
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" href="/">
          <img className="logo" src={logo} alt="Logo" />
            {/* Deft Technologies */}
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
          <li>
              <a href="/" className="page-scroll">
                Home
              </a>
            </li>
            <li>
              <div className="dropdown dropdown-hover">
                <div tabIndex={0} role="button" className="page-scroll m-1">
                  Company
                  <span className="caret-icon"></span> {/* Caret Icon */}
                </div>
                <ul tabIndex={0} className="dropdown-content menu bg-base-100 rounded-box">
                  <li><a href="#values">Mission & Vision</a></li>
                  <li><a href="#partner">Partners</a></li>
                  <li><a href="#testimonials">Testimonials</a></li>
                  <li><Link to="/careers">Careers</Link></li>
                </ul>
              </div>
            </li>
            <li>
              <div className="dropdown dropdown-hover">
                <div tabIndex={0} role="button" className="page-scroll m-1">
                  Industries
                  <span className="caret-icon"></span> {/* Caret Icon */}
                </div>
                <ul tabIndex={0} className="dropdown-content menu bg-base-100 rounded-box">
                  <li><a href="#">Hospitality</a></li>
                  <li><a href="#">Health</a></li>
                  <li><a href="#partner">Education</a></li>
                  <li><a href="#">Finance</a></li>
                  <li><a href="#">NGOs</a></li>
                </ul>
              </div>
            </li>
            <li>
              <div className="dropdown dropdown-hover">
                <div tabIndex={0} role="button" className="page-scroll m-1">
                  Solutions
                  <span className="caret-icon"></span> {/* Caret Icon */}
                </div>
                <ul tabIndex={0} className="dropdown-content menu bg-base-100 rounded-box">
                  <li><a href="#feature-0">Financial Management Solutions</a></li>
                  <li><a href="#feature-1">Academics Solutions</a></li>
                  <li><a href="#feature-2">HMIS Solutions</a></li>
                  <li><a href="#feature-3">NGO Management Solutions</a></li>
                  <li><a href="#feature-4">Public Sector Solutions</a></li>
                  <li><a href="#feature-5">Hospitality Management Solutions</a></li>
                  <li><a href="#feature-6">Analytics & Reporting Solutions</a></li>
                  <li><a href="#feature-7">Bespoke Solutions</a></li>
                </ul>
              </div>
            </li>

            <li>
              <a href="#about" className="page-scroll">
                About Us
              </a>
            </li>
            <li>
              <a href="#testimonials" className="page-scroll">
                Testimonials
              </a>
            </li>
            {/* <li>
              <a href="#team" className="page-scroll">
                Team
              </a>
            </li> */}
            <li>
              <div className="nav-btn">
                <a href="#contact" className="btn btn-custom btn-lg page-scroll">
                  Get Started
                </a>{" "}
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
